import { sleep } from ".";

/** Vue 3's nextTick() seems to only do one queued state change at a time - this will clear the whole queue, somehow. */
export function flushVueQueue() {
  return sleep(0);
}
